const ZINDEX = {
  BASE: 0,
  MIN: 1,
  HEADER: 10,
  MENU_OVERLAY: 20,
  PROGRESS_BAR: 100,
};

export default ZINDEX;
